import React, { Component } from "react";
import "./Login.scss";
//import { AppState } from '../../stores/AppState';

import { inject, observer } from "mobx-react";
import { AppStore } from "~/stores/AppStore";
import { makeObservable, observable, action } from "mobx";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { Button, Input, Alert, Select, Spin } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHome, faCloud, faSpinner, faUser, faLock, faArrowRightToBracket } from "@fortawesome/free-solid-svg-icons";
import { faGoogle, faWindows } from "@fortawesome/free-brands-svg-icons";
import packageJson from "../../../package.json";
import { config } from "../../config/configUi";
import { Navigate } from "react-router-dom";

const { Option } = Select;

dayjs.extend(utc);
dayjs.extend(timezone);

dayjs.tz.setDefault("Europe/Rome");

interface Props {
  store?: any;
}

@inject("store")
@observer
export default class Home extends Component<Props> {
  store: AppStore;
  errorMsg: string = "";
  loading: boolean = false;
  authMethod: string = "local";
  resetPasswordDialogActive = false;
  resetPasswordLoading = false;
  resetPasswordErrorMsg = "";

  userPayload: any = {
    clientRef: localStorage.getItem("authClientRef") || "",
    username: "",
    password: "",
  };

  resetPasswordPayload = {
    clientRef: "",
    username: "",
    currentPassword: "",
    newPassword: "",
    password: "",
    confirmNewPassword: "",
  };

  constructor(props: any) {
    super(props);
    makeObservable(this, {
      loading: observable,
      errorMsg: observable,
      authMethod: observable,
      resetPasswordDialogActive: observable,
      resetPasswordPayload: observable,
      resetPasswordLoading: observable,
      userPayload: observable,
      setErrorMsg: action,
      setLoading: action,
      //resetPasswordErrorMsg: observable,
    });

    this.store = props.store;
  }

  componentDidMount() {
    if (window.location.search) {
      const urlParams = new URLSearchParams(window.location.search);
      this.errorMsg = urlParams.get("msg");

      // If the url params has re-login, we login user automatically
      if (urlParams.get("reLogin")) {
        this.handleFormSubmit(null);
      }
    }
  }

  setErrorMsg = (value) => {
    this.errorMsg = value;
  };

  setLoading = (value) => {
    this.loading = value;
  };

  randomString = function (length: number) {
    let text = "";
    const possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < length; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  };

  updateProperty = (key: any, value: any, resetPassword = false) => {
    if (key === "clientRef") {
      value = value.toUpperCase();
    }

    if (resetPassword) {
      //this.resetPasswordPayload[key] = value
    } else {
      this.userPayload[key] = value;
    }
  };

  handleChangeValue = (event: any, resetPassword = false) => {
    this.updateProperty(event.target.id, event.target.value, resetPassword);
  };

  private onChange = (value: any) => {
    this.authMethod = value;

    localStorage.setItem("authMethod", value);
  };

  handleFormSubmit = (event: any) => {
    // Prevent Click.
    event && event.preventDefault();

    //Reset error messages
    this.setErrorMsg("");
    //this.resetPasswordErrorMsg = ''

    //check if reset modal is open
    //if (!this.resetPasswordDialogActive) {
    // Set up login endpoint.
    let signInEndpoint = "";
    let userInfo: any = {};

    // Check if user info is valid.
    let valid = this.validateInfo();

    // If not valid return.
    if (!valid) {
      return;
    }

    // Set loading flag.
    this.setLoading(true);

    localStorage.setItem("authClientRef", this.userPayload.clientRef);

    // Add set the URL Type to use which API component.
    let urlType = "main";

    const isLocalHost = window.location.hostname === "localhost";

    // Check if local login method.
    if (this.authMethod === "local") {
      // Set the signin endpoint.
      signInEndpoint = "auth/token";
      // Setup the user info payload.
      userInfo = {
        grant_type: "password",
        client_key: "ScCws1zdSUR3xGIRHDyGck+6tE04b8Af+H3lIcbSD1M=",
        client_ref: this.userPayload.clientRef,
        username: this.userPayload.username,
        password: this.userPayload.password,
        scopes: "admin",
      };
    }
    // Check if MLAuth login method.
    if (this.authMethod === "mlauth") {
      // Set the signin endpoint.
      signInEndpoint = "auth/mlauth";
      // Setup the user info payload.
      userInfo = {
        grant_type: "password",
        client_key: "ScCws1zdSUR3xGIRHDyGck+6tE04b8Af+H3lIcbSD1M=",
        client_ref: this.userPayload.clientRef,
        username: this.userPayload.username,
        password: this.userPayload.password,
        scopes: "admin",
      };
    }
    // Check if the sign in is google.
    else if (this.authMethod === "google") {
      // Get the base URL of application.
      const baseUrl = window.location.origin;
      // Get base INIT API endpoint from config.
      const authBaseUrl = "xxx"; //config.apiAddress[urlType];
      // Set the signin endpoint.
      signInEndpoint = "auth/google";
      // Define callback and loginURL.
      const callbackUrl = "/google_callback_success";
      const loginUrl = "/login";
      // Generate and store the nonce key.
      let nonce = ""; //encodeURIComponent(crypto.randomBytes(16).toString("base64"));
      // Remove nonce.
      window.localStorage.removeItem("of_lognonce");
      // Save the nonce to local storage.
      window.localStorage.setItem("of_lognonce", nonce);
      // Setup the user info payload for google.
      userInfo = {
        grant_type: "password",
        client_key: encodeURIComponent("ScCws1zdSUR3xGIRHDyGck+6tE04b8Af+H3lIcbSD1M="),
        client_ref: this.userPayload.clientRef,
        scopes: "admin",
        auth_base_url: encodeURIComponent(authBaseUrl),
        base_url: encodeURIComponent(baseUrl),
        callback: encodeURIComponent(callbackUrl),
        login: encodeURIComponent(loginUrl),
        of_lognonce: nonce,
      };
      // Get the URL params and check if a reqURL is present.
      const urlParams = new URLSearchParams(window.location.search);
      const reqUrl = urlParams.get("reqUrl") ? urlParams.get("reqUrl") : null;
      // If present, pass to Google auth.
      if (reqUrl) {
        userInfo.reqUrl = encodeURIComponent(reqUrl);
      }
      // Generate the query string.
      const queryString = Object.keys(userInfo)
        .map((key) => key + "=" + userInfo[key])
        .join("&");

      // // Log.
      // console.log('Pre Login Query URL - ', queryString)

      // Redirect to google sign in.
      window.location.href = authBaseUrl + signInEndpoint + "?" + queryString;
      // Return.
      return;
    }
    // Check if the sign in is azure.
    else if (this.authMethod === "azure") {
      //console.log("config", config);
      // Get the base URL of application.
      const baseUrl = window.location.origin;

      let authBaseUrl = baseUrl + config.virtualPath["main"];

      if (isLocalHost) {
        // Get base INIT API endpoint from config.
        authBaseUrl = config.apiAddress["main"] + config.virtualPath["main"];
      }

      // Set the signin endpoint.
      signInEndpoint = "auth/azure";
      // Define callback and loginURL.
      const callbackUrl = "/azure_callback_success";
      const loginUrl = "/login";
      // Generate and store the nonce key.
      let nonce = encodeURIComponent(this.randomString(16));
      // Remove nonce.
      window.localStorage.removeItem("of_lognonce");
      // Save the nonce to local storage.
      window.localStorage.setItem("of_lognonce", nonce);
      // Setup the user info payload for azure.
      userInfo = {
        grant_type: "password",
        client_key: encodeURIComponent("ScCws1zdSUR3xGIRHDyGck+6tE04b8Af+H3lIcbSD1M="),
        client_ref: this.userPayload.clientRef,
        scopes: "admin",
        auth_base_url: encodeURIComponent(authBaseUrl),
        base_url: encodeURIComponent(baseUrl),
        callback: encodeURIComponent(callbackUrl),
        login: encodeURIComponent(loginUrl),
        of_lognonce: nonce,
      };
      // Get the URL params and check if a reqURL is present.
      const urlParams = new URLSearchParams(window.location.search);
      const reqUrl = urlParams.get("reqUrl") ? urlParams.get("reqUrl") : null;
      // If present, pass to azure auth.
      if (reqUrl) {
        userInfo.reqUrl = encodeURIComponent(reqUrl);
      }
      // Generate the query string.
      const queryString = Object.keys(userInfo)
        .map((key) => key + "=" + userInfo[key])
        .join("&");

      // // Log.
      // console.log('Pre Login Query URL - ', queryString)

      // Redirect to azure sign in.
      window.location.href = authBaseUrl + signInEndpoint + "?" + queryString;
      // Return.
      return;
    }

    // Try to sign in.
    this.props.store
      .postData(signInEndpoint, userInfo, urlType)
      .then((login: any) => {
        // Set the access token.
        this.props.store.user.accessToken = login.accessToken;
        // Set loading false.
        this.loading = false;

        // Post sign in success.
        this.props.store.postSignIn(userInfo.username, userInfo.client_ref, login);
      })
      .catch((err: any) => {
        // Error.
        this.props.store.consoleLog("Login:", JSON.stringify(err));
        // Set flag.
        this.loading = false;
        if (err.response && err.response.status === 400) {
          this.showErrorModal(err.response.data && err.response.data.message && err.response.data.message.toUpperCase());
        } else if (err.response && err.response.status === 401 && err.response?.data?.passwordExpired) {
          //password has expired rest is required
          this.resetPasswordPayload.clientRef = this.userPayload.clientRef;
          this.resetPasswordPayload.username = this.userPayload.username;
          this.resetPasswordPayload.password = this.userPayload.password;
          this.resetPasswordPayload.newPassword = "";
          this.resetPasswordPayload.confirmNewPassword = "";
          //Show Reset Password Modal
          this.resetPasswordDialogActive = true;
        } else {
          this.showErrorModal("Failed to connect to server. Please try again!");
          throw err;
        }
      });
    //}
  };

  private showErrorModal(message: any, resetPassword = false) {
    if (resetPassword) {
      this.resetPasswordErrorMsg = message;
    } else {
      this.errorMsg = message;
    }
  }

  // Validations
  private validateInfo(resetPassword = false) {
    //Validate Reset Password Form
    if (resetPassword) {
      if (!this.resetPasswordPayload.username) {
        this.showErrorModal("Please enter the username.", true);
        return false;
      }
      if (!this.resetPasswordPayload.currentPassword) {
        this.showErrorModal("Please enter the current password.", true);
        return false;
      }

      if (!this.resetPasswordPayload.newPassword) {
        this.showErrorModal("Please enter the new password.", true);
        return false;
      }

      if (!this.resetPasswordPayload.confirmNewPassword) {
        this.showErrorModal("Please enter confirm new password.", true);
        return false;
      }

      if (this.resetPasswordPayload.newPassword.trim() !== this.resetPasswordPayload.confirmNewPassword.trim()) {
        this.showErrorModal("Confirmed password does not match.", true);
        return false;
      }
    } else {
      if (this.authMethod === "local" || this.authMethod === "mlauth") {
        // Validate client ref.
        if (!this.userPayload.clientRef) {
          this.showErrorModal("Please enter the client.");
          return false;
        }
        //Validate Login Form
        if (!this.userPayload.username) {
          this.showErrorModal("Please enter the username.");
          return false;
        }

        if (!this.userPayload.password) {
          this.showErrorModal("Please enter the password.");
          return false;
        }
      }
      if (this.authMethod === "google" || this.authMethod === "azure") {
        // Validate client ref.
        if (!this.userPayload.clientRef) {
          this.showErrorModal("Please enter the client.");
          return false;
        }
      }
    }
    return true;
  }

  private renderAuthMethod = () => {
    // Get the auth methods.
    //const authMethods = ["local", "google", "azure", "mlauth"];
    const authMethods = ["local"];

    // If there are no auth methods, or only one, we don't allow selection.
    if (authMethods.length < 2) {
      return null;
    }

    // Define the auth options.
    let authOptions: any = [];

    authMethods.forEach((authType, index) => {
      // Set the icon type.
      let icon,
        authText = "";
      switch (authType) {
        case "google":
          icon = <FontAwesomeIcon icon={faGoogle} className="mr-2 text-gray-400" />;
          authText = "Google";
          break;
        case "azure":
          icon = <FontAwesomeIcon icon={faWindows} className="mr-2 text-gray-400" />;
          authText = "Microsoft";
          break;
        case "mlauth":
          icon = <FontAwesomeIcon icon={faCloud} className="mr-2 text-gray-400" />;
          authText = "MLAuth";
          break;
        default:
          icon = <FontAwesomeIcon icon={faHome} className="mr-2 text-gray-400" />;
          authText = "Local";
      }
      // Set the auth options in the dropdown.
      authOptions.push(
        <Option data-e2e={"login-authmethod-" + authType} value={authType} key={index}>
          {icon}
          {authText}
        </Option>
      );
    });

    return (
      <div style={{ marginBottom: 10 }}>
        <div className="descriptor">Auth Method</div>
        <Select data-e2e="login-authmethod" showSearch={false} style={{ width: "100%", textAlign: "left" }} value={this.authMethod} placeholder="Select auth method" onChange={this.onChange}>
          {authOptions}
        </Select>
      </div>
    );
  };

  renderLoginButton = () => {
    const { loadingUserProfile, authenticated } = this.props.store;

    // Handling for local login details.
    if (this.authMethod === "local" || this.authMethod === "mlauth") {
      return (
        <div
          className="action"
          style={{
            paddingBottom: "5px",
          }}
        >
          <Button
            data-e2e="login-btn"
            type="primary"
            htmlType="submit"
            size="large"
            disabled={this.loading || authenticated || loadingUserProfile}
            style={{
              width: "100%",
            }}
            onClick={(e) => this.handleFormSubmit(e)}
          >
            <div className="align-middle flex">
              <div className="mr-auto ml-auto">
                {/* <Icon type={this.loading || loadingUserProfile ? "loading" : "login"} className="mr-2" /> */}
                <FontAwesomeIcon icon={this.loading ? faSpinner : faArrowRightToBracket} className="mr-4" />
                <span>Login</span>
              </div>
            </div>
          </Button>
        </div>
      );
    }

    // Handling for google login details.
    if (this.authMethod === "google") {
      return (
        <Button
          data-e2e="login-btn"
          type="primary"
          htmlType="submit"
          size="large"
          disabled={this.loading || authenticated || loadingUserProfile}
          style={{
            width: "100%",
          }}
          onClick={(e) => this.handleFormSubmit(e)}
        >
          <div className="align-middle flex">
            <div className="mr-auto ml-auto">
              {/* <Icon type={this.loading || loadingUserProfile ? "loading" : "google"} className="mr-2" /> */}
              <FontAwesomeIcon icon={this.loading ? faSpinner : faGoogle} className="mr-4" />
              <span>{"Sign in with Google"}</span>
            </div>
          </div>
        </Button>
      );
    }

    // Handling for google login details.
    if (this.authMethod === "azure") {
      return (
        <Button
          data-e2e="login-btn"
          type="primary"
          htmlType="submit"
          size="large"
          disabled={this.loading || authenticated || loadingUserProfile}
          style={{
            width: "100%",
          }}
          onClick={(e) => this.handleFormSubmit(e)}
        >
          <div className="align-middle flex">
            <div className="mr-auto ml-auto">
              {/* <Icon type={this.loading || loadingUserProfile ? "loading" : "windows"} className="mr-2" /> */}
              <FontAwesomeIcon icon={this.loading ? faSpinner : faWindows} className="mr-4" />
              <span>{"Sign in with Microsoft"}</span>
            </div>
          </div>
        </Button>
      );
    }
  };

  public render() {
    // If auth redirect to home page.
    if (this.props.store.authenticated && !this.props.store.isRedirecting) {
      return <Navigate to="/home" />;
    }

    return (
      <div className="loginContainer">
        <div className="login">
          <div className="branding">
            <div data-e2e="login-logo" className="logo" />
            <div data-e2e="login-title" className="title">
              <h4 style={{ color: "#fff" }} className="mb-3 text-4xl">
                openFleet Pro
              </h4>
              <h5 className="text-3xl mt-0 text-blue-500">Management Portal</h5>
            </div>
          </div>

          <div className="formContainer">
            <Spin
              tip={this.props.store.isRedirecting ? "Redirecting..." : "Fetching your details..."}
              spinning={this.props.store.loadingUserProfile}
              //indicator={<Icon style={{ color: "#1890ff" }} type="loading" />}
              indicator={<FontAwesomeIcon icon={faSpinner} className="mr-2" />}
              size="large"
            >
              <form
                className="loginForm"
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    // Handle the enter click.
                    this.handleFormSubmit(e);
                  }
                }}
              >
                <section className="section">
                  {this.errorMsg && <Alert data-e2e="login-validation-modal" message={this.errorMsg} type="error" showIcon={true} style={{ marginBottom: 10 }} />}

                  {this.renderAuthMethod()}
                  {
                    <div>
                      <div className="descriptor">Partner Ref</div>
                      <Input
                        data-e2e="login-clientRef"
                        prefix={<FontAwesomeIcon icon={faUser} className="mr-2 text-gray-400" />}
                        placeholder="Client"
                        id="clientRef"
                        value={this.userPayload.clientRef}
                        disabled={this.loading}
                        onChange={(e) => this.handleChangeValue(e)}
                        style={{ marginBottom: "10px" }}
                        allowClear={true}
                        autoFocus={true}
                      />
                    </div>
                  }
                  {(this.authMethod === "local" || this.authMethod === "mlauth") && (
                    <div>
                      <div className="descriptor">Username</div>
                      <Input
                        data-e2e="login-username"
                        // prefix={<Icon type="user" style={{ color: "rgba(0,0,0,.25)" }} />}
                        prefix={<FontAwesomeIcon icon={faUser} className="mr-2 text-gray-400" />}
                        placeholder="Username"
                        autoComplete="username"
                        id="username"
                        value={this.userPayload.username}
                        disabled={this.loading}
                        onChange={(e) => this.handleChangeValue(e)}
                        style={{ marginBottom: "10px" }}
                      />
                    </div>
                  )}
                  {(this.authMethod === "local" || this.authMethod === "mlauth") && (
                    <div>
                      <div className="descriptor">Password</div>
                      <Input
                        data-e2e="login-password"
                        // prefix={<Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />}
                        prefix={<FontAwesomeIcon icon={faLock} className="mr-2 text-gray-400" />}
                        type="password"
                        autoComplete="current-password"
                        id="password"
                        placeholder="Password"
                        value={this.userPayload.password}
                        disabled={this.loading}
                        onChange={(e) => this.handleChangeValue(e)}
                        style={{ marginBottom: "10px" }}
                      />
                    </div>
                  )}
                </section>

                {this.renderLoginButton()}

                {/* <Modal
                  title={t('lblResetPassword', 'Reset Password')}
                  closable={false}
                  centered
                  visible={this.resetPasswordDialogActive}
                  footer={this.renderFooter()}
                  onCancel={this.handleResetToggle}
                  key='resetPasswordModal'
                  width={'350px'}
                >
                  <div>{this.renderResetPasswordContent()}</div>
                </Modal> */}

                <div className="version">{packageJson.version && "Version " + packageJson.version.toString()}</div>
              </form>

              {/* {haveClientLogos && (
                <div className='customLogos'>
                  {this.props.store.getCustomLogo() && (
                    <div>
                      <img src={this.props.store.getCustomLogo()} style={{ height: 22 }} />
                    </div>
                  )}
                  {this.props.store.getCustomLogo(false) && (
                    <div>
                      <img src={this.props.store.getCustomLogo(false)} style={{ height: 22 }} />
                    </div>
                  )}
                </div>
              )} */}
            </Spin>
          </div>

          {/* {this.props.store.showEasterEgg() && <HeartBg />} */}
        </div>
      </div>
    );
  }
}
